
<div>
  <v-dialog persistent width="600" height="400" v-model="showDeleteModal" class="delete-dialog" hide-overlay>
    <v-card class="pa-5">
      <h4>Are you sure you want to delete this document? This cannot be undone.</h4>
      <div class="d-flex justify-end">
         <button @click="closeDeleteModal"  class="btn btn-outline-primary">Cancel</button>
         <button @click="deleteDocument" class="btn btn-danger ml-2">Delete</button>
      </div>
    </v-card>
  </v-dialog>
  <v-dialog persistent scrollable v-model="showLightbox" class="preview-dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card class="d-flex flex-column">
      <v-toolbar height="100px" style="flex: 0 0 auto">
        <div class="d-flex flex-column py-3">
          <h5 v-if="!editingName" @click="openChangeName" :alt="doc.name" class="mb-0 hover d-flex align-items-center" @mouseover="hover = true" @mouseleave="hover = false" style="width: 45rem;">
            <b class="truncate-doc-name">{{doc.name}}</b>
            <v-icon small v-if="hover">mdi-pencil</v-icon>
          </h5>
          <v-text-field v-if="editingName"
          @keyup.enter="changeName"
          dense
          single-line
          hide-details
          v-model="newName"
          class="edit-name-field pb-0"
          append-outer-icon="mdi-close"
          @click:append-outer="closeChangeName"/>
          <a v-if="hasCases" :href="'/dashboard/cases/' + caseId" style="flex: 1 1 auto;">{{ displayCaseNames }}</a>
          <span v-else style="flex: 1 1 auto;">
            <i>No assigned case</i>
          </span>
          <span class="grey--text">{{prettyDate(doc.created_at)}}</span>
        </div>
        <v-spacer></v-spacer>
        <a :href="downloadPath" :download="doc.name">
        <button type="button" class="mr-2 btn btn-sm btn-primary">
          {{ isDownloading ? 'Downloading...' : `Download` }}
        </button>
        </a>

         <button type="button" class="mr-2 btn btn-sm btn-danger"  @click="openDeleteModal">
          Delete
        </button>

        <v-btn icon @click="closeLightbox">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container v-if="isFileLarge" fluid class="grey lighten-1 d-flex flex-column" style="flex: 1 1 auto;">
        <div class="no-preview">
          <div class="d-flex align-items-center">
            <v-icon color="#FA9917" class="mr-2">mdi-alert</v-icon>
            <h2 style="font-size: 20px; font-weight: 700;" class="ma-0">The document you selected is too large to preview.</h2>
          </div>
          <span class="my-4">Please download to view this document.</span>
          <a :href="downloadPath" :download="doc.name" @click="handleDownload">
            <v-btn small color="primary">
              <v-icon small class="mr-1">mdi-download</v-icon> Download
            </v-btn>
          </a>
          <div v-if="isDownloading" class="alert m-0 pl-8 pr-0 position-absolute" style="top: 100px; right: 8px;">
            <v-alert type="success" dense class="mb-0">
              Please wait, your file will automatically download.
            </v-alert>
          </div>
        </div>
      </v-container>
      <v-container v-else-if="previewLoaded" fluid class="grey lighten-1 d-flex flex-column" style="flex: 1 1 auto; overflow-y: scroll; overflow-x: hidden">
        <img class="mx-auto" v-if="previewType === 'image'" :src="previewUrl" style="max-width: 80%; max-height: 100%"></img>
        <div v-else-if="doc.extension === 'pdf'" class="pdf">
          <pdf
            v-for="i in pdfPages"
            :key="i"
            :src="previewUrl"
            :page="i"
            style="width: 60%;"
            class="mx-auto"
          ></pdf>
        </div>
        <video class="mx-auto" controls v-else-if="doc.extension === 'mp4'" :src="previewUrl" style="max-width: 80%;"></video>
        <h1 v-else class="grey--text ma-auto">No preview available for this type of document.</h1>
      </v-container>
      <v-container v-else fluid class="grey lighten-1 d-flex flex-column" style="flex: 1 1 auto; overflow-y: scroll; overflow-x: hidden">
        <h1 class="grey--text ma-auto">Loading preview...</h1>
      </v-container>
    </v-card>
  </v-dialog>
</div>
